module.exports = __webpack_public_path__ + "static/media/homestay_taiwan.6c65fd04.jpg";